import { Injectable } from '@angular/core';
import { CandidateProfileSmEvents, CandidateProfileMachineConfig, CandidateProfileContext } from './candidate-profile.sm';
import { Machine, interpret, State, MachineOptions } from 'xstate';

@Injectable({
  providedIn: 'root'
})
export class CandidateProfileMachineService {

  isRecruiter: Function;
  isPTC: Function;
  canApprove: Function;
  isInvite: Function;
  isRecruiterReject: Function



  private machineOptions: Partial<MachineOptions<CandidateProfileContext, CandidateProfileSmEvents>> = {
    guards: {
      isRecruiter: (ctx, evt) => this.isRecruiter(),
      isPTC: (ctx, evt) => this.isPTC(),
      canApprove: (ctx, evt) => this.canApprove(),
      canReject: (ctx, evt) => this.isPTC() && this.canApprove(),
      isInvite: (ctx, evt) => this.isInvite(),
      isRecruitedAndNotInvited: (ctx, evt) => this.isRecruiter() && !this.isInvite(),
      isRecruiterReject: (ctx, evt) => this.isRecruiter() && this.isRecruiterReject()

    }
  }

  private _machine = Machine(CandidateProfileMachineConfig).withConfig(this.machineOptions);

  private onTransition = (state) => { this.currFsmState = state; };

  private _service = interpret(this._machine, { devTools: false });//.onTransition(this.onTransition).start();

  private _currFsmState: State<CandidateProfileContext, CandidateProfileSmEvents> = this._service.machine.initialState;
  private _validEvents: string[];

  constructor() { }

  send(event: CandidateProfileSmEvents) {
    this._service.send(event);
  }

  private getValidFsmEvents(): string[] {
    if (this.currFsmState != null) {

      return this.currFsmState.nextEvents.filter(nextEvent => {
        return this._machine.transition(this.currFsmState, <CandidateProfileSmEvents>{ type: nextEvent }).changed;
      });
    } else {
      return [];
    }
  }

  getValidEvents() {
    return this._validEvents;
  }
  getAllStates() {
    return this._machine.states;
  }

  start(initialState?: string | State<CandidateProfileContext, CandidateProfileSmEvents>) {
    this._service.stop();
    this._service = this._service.onTransition(this.onTransition).start(initialState);
    this.currFsmState = this._service.state;
  }

  get currFsmState() {
    return this._currFsmState;
  }

  set currFsmState(state: State<CandidateProfileContext, CandidateProfileSmEvents>) {
    this._currFsmState = state;
    this._validEvents = this.getValidFsmEvents();
  }

  get InitialState() {
    return this._service.initialState;
  }
}